// extracted by mini-css-extract-plugin
export var contentWrapper = "Topics-module--content-wrapper--33b35";
export var header = "Topics-module--header--36fe1";
export var mobileWrapper = "Topics-module--mobile-wrapper--3fce6";
export var topicPageWrapper = "Topics-module--topic-page-wrapper--d2088";